import { createFileRoute } from '@tanstack/react-router';
import { surveyQuery, surveyResponsesQuery, surveySummaryQuery } from '@/features/surveys/api';
import { SurveyPage } from '@/features/surveys/pages/SurveyPage';
import { surveySearchSchema } from '@/features/surveys/search';

export const Route = createFileRoute('/_authed/ops/surveys/$surveyId')({
  staticData: { help: 'surveys' },
  validateSearch: surveySearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, params, deps }) => {
    void queryClient.prefetchQuery(surveyQuery(params.surveyId));
    if (deps.tab !== 'responses' && deps.tab !== 'setup') {
      void queryClient.prefetchQuery(surveySummaryQuery(params.surveyId));
    }
    if (deps.tab === 'responses') {
      void queryClient.prefetchQuery(surveyResponsesQuery(params.surveyId, deps.page));
    }
  },
  component: SurveyPage,
});
